/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgHandBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.8999 4.575C13.8999 3.70515 14.6051 3 15.4749 3C16.3448 3 17.0499 3.70515 17.0499 4.575L17.05 7.575M13.8999 4.575L13.8999 3.075C13.8999 2.20515 13.1948 1.5 12.3249 1.5C11.4551 1.5 10.7499 2.20515 10.7499 3.075L10.7499 4.575M13.8999 4.575L13.825 10.5M10.7499 11.25V4.575M10.7499 4.575C10.7499 3.70515 10.0448 3 9.17492 3C8.30507 3 7.59992 3.70515 7.59992 4.575V15H7.59801M17.05 7.575C17.05 6.70515 17.7551 6 18.625 6C19.4948 6 20.2 6.70515 20.2 7.575V15.75C20.2 19.4779 17.1779 22.5 13.45 22.5H11.4321C10.0397 22.5 8.70433 21.9469 7.71976 20.9623L5.98764 19.2302C5.00308 18.2456 4.44995 16.9103 4.44995 15.5179L4.4469 13.494C4.4454 13.3209 4.37985 13.1533 4.24922 13.0227C3.63415 12.4076 3.63415 11.4104 4.24922 10.7953C4.8643 10.1802 5.86153 10.1802 6.47661 10.7953C7.21842 11.5371 7.5922 12.5111 7.59688 13.4815M17.05 7.575V12"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SvgHand = wrapIcon(SvgHandBase);
export default SvgHand;
